import React, { useContext, useEffect, useRef, useState } from "react";
import { Alert, Box, Button } from "@intech/web-ui";
import { PlanoService, RecadastramentoService } from "@services";
import { DMN_SITUACAO_RECAD, DMN_SITUACAO_RECAD_BUSCAR_NOME, TYP_SITUACAO_RECAD } from "@domains";
import { RecadastramentoContext } from "@contexts";
import { WebRecadParticipanteDadosEntidade, WebRecadPublicoAlvoEntidade } from "@entidades";
import { LoadingComponent } from "@components";
import { FaCheck } from "react-icons/fa";

interface IProps {
  salvarListaPassosDisponiveis: (parametros: number[], parametro: string) => Promise<void>;
  avancar: (PassoEspecifico?: number | null) => Promise<void>;
}

export const SituacaoRecad: React.FC<IProps> = ({
  salvarListaPassosDisponiveis,
  avancar
}) => {
  const context = useContext(RecadastramentoContext);
  const isMountedRef = useRef(true);

  const [RecadSelecionado, setRecadSelecionado] = useState<WebRecadPublicoAlvoEntidade>(null);
  const [RecadastramentosDisponiveis, setRecadastramentosDisponiveis] = useState<WebRecadPublicoAlvoEntidade[]>([]);
  const [CdPlano, setCdPlano] = useState<string>("");

  const [Loading, setLoading] = useState<boolean>(true);
  const [Erro, setErro] = useState<string>("");

  useEffect(() => () => { isMountedRef.current = false }, []);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        if (!isMountedRef.current)
          return;

        await context.limparDados();

        const Recads = await RecadastramentoService.BuscarPorCpf();

        const planos = await PlanoService.Buscar();

        const temPlano = planos.length > 0;

        const cdPlano = temPlano ? planos[0].CD_PLANO : "";
        setCdPlano(cdPlano);

        if (Recads.length === 1 && Recads[0].IND_SITUACAO_RECAD !== DMN_SITUACAO_RECAD.NAO_HA) {
          await HandleSelecionarRecad(Recads[0], cdPlano);
          return;
        }
        else {
          if (Recads.length === 1) {
            setRecadSelecionado(Recads[0]);
            return;
          }
        }
        // context.salvarRecadastramentosDisponiveis(Recads);
        setRecadastramentosDisponiveis(Recads);
      } catch (e) {
        const error: any = e;
        const messsage = error.response ? error.response.data : error;
        setErro(messsage);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  async function MontarDadosRecadastramento(Recad: WebRecadPublicoAlvoEntidade, cdPlano: string) {
    try {
      const RecadDados = await RecadastramentoService.BuscarDadosPorCpf(Recad.OID_RECAD_PUBLICO_ALVO);

      context.salvarDadosRecadastramento(Recad);
      context.salvarDadosParticipante(new WebRecadParticipanteDadosEntidade());
      context.salvarDadosOriginais(RecadDados);

      const listaPassos = await RecadastramentoService.BuscarPassosDisponiveis(Recad.OID_RECAD_PUBLICO_ALVO);
      await salvarListaPassosDisponiveis(listaPassos, cdPlano);
    } catch (e) {
      const err: any = e;
      const erro = err.response ? err.response.data : err;
      setErro(erro);
    }
  }

  async function HandleSelecionarRecad(recad: WebRecadPublicoAlvoEntidade, cdPlano: string) {
    if (recad.IND_SITUACAO_RECAD === DMN_SITUACAO_RECAD.AGUARDANDO || recad.IND_SITUACAO_RECAD === DMN_SITUACAO_RECAD.RECUSADO) {
      await MontarDadosRecadastramento(recad, cdPlano);
      avancar();
    }
    else {
      setRecadSelecionado(recad);
    }
  }

  return (
    <>
      {Loading && <LoadingComponent />}

      {!Loading && Erro && <Alert type={'danger'}>{Erro}</Alert>}

      {!Loading && !Erro && (
        <>
          {RecadSelecionado && <Alert type={"info"}>{RecadSelecionado.TEXTO_RECAD}</Alert>}

          {RecadastramentosDisponiveis.length > 1 && !RecadSelecionado && <>
            <>
              <h4>
                {"Selecione uma matrícula/perfil para iniciar o recadastramento:"}
              </h4>

              <table className={"table table-responsive table=bordered"}>
                <thead>
                  <tr>
                    <th>{"Matrícula"}</th>
                    <th>{"Nome da Campanha"}</th>
                    <th>{"Situação Recadastramento"}</th>
                    <th></th>
                  </tr>
                </thead>

                <tbody>
                  {RecadastramentosDisponiveis.map((recad: WebRecadPublicoAlvoEntidade, index: number) => {
                    return (
                      <tr key={index}>
                        <td>{recad.NUM_MATRICULA}</td>
                        <td>{recad.NOM_CAMPANHA}</td>
                        <td>{DMN_SITUACAO_RECAD_BUSCAR_NOME(recad.IND_SITUACAO_RECAD as TYP_SITUACAO_RECAD)}</td>
                        <td>
                          <Button
                            onClick={async () => HandleSelecionarRecad(recad, CdPlano)}
                            title={"Selecionar Matrícula"}
                            type={"primary"}
                            icon={<FaCheck />}
                            usesLoading
                            loadingText={"Selecionando..."}
                          />
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </>
          </>}
        </>
      )}
    </>
  );
}